import React from 'react';
import { UpdateCaseRequest } from '../../services/api';
import { X } from 'lucide-react';
import './CaseModals.css';

interface EditCaseModalProps {
  isOpen: boolean;
  editData: UpdateCaseRequest;
  setEditData: (data: UpdateCaseRequest) => void;
  isUpdating: boolean;
  onClose: () => void;
  onUpdate: () => void;
}

const EditCaseModal: React.FC<EditCaseModalProps> = ({
  isOpen,
  editData,
  setEditData,
  isUpdating,
  onClose,
  onUpdate,
}) => {
  if (!isOpen) return null;

  return (
    <>
      <div className="modal-backdrop" onClick={onClose}></div>
      <div className="edit-case-modal">
        <div className="modal-header">
          <h2>Edit Case</h2>
          <button onClick={onClose} className="close-modal-btn">
            <X size={24} />
          </button>
        </div>

        <div className="modal-content">
          <div className="form-group">
            <label htmlFor="edit-projectName">Project Name</label>
            <input
              id="edit-projectName"
              type="text"
              value={editData.projectName || ''}
              onChange={(e) => setEditData({ ...editData, projectName: e.target.value })}
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label htmlFor="edit-clientName">Client Name</label>
            <input
              id="edit-clientName"
              type="text"
              value={editData.clientName || ''}
              onChange={(e) => setEditData({ ...editData, clientName: e.target.value })}
              className="form-input"
            />
          </div>

          <div className="form-row">
            <div className="form-group">
              <label htmlFor="edit-status">Status</label>
              <select
                id="edit-status"
                value={editData.status || 'Open'}
                onChange={(e) => setEditData({ ...editData, status: e.target.value })}
                className="form-select"
              >
                <option value="Open">Open</option>
                <option value="Archived">Archived</option>
                <option value="Closed">Closed</option>
              </select>
            </div>

            <div className="form-group">
              <label htmlFor="edit-phase">Phase</label>
              <select
                id="edit-phase"
                value={editData.phase || 'Initial'}
                onChange={(e) => setEditData({ ...editData, phase: e.target.value })}
                className="form-select"
              >
                <option value="Initial">Initial</option>
                <option value="Discovery">Discovery</option>
                <option value="Trial">Trial</option>
                <option value="Settlement">Settlement</option>
                <option value="Closed">Closed</option>
              </select>
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="edit-description">Description</label>
            <textarea
              id="edit-description"
              value={editData.description || ''}
              onChange={(e) => setEditData({ ...editData, description: e.target.value })}
              placeholder="Case description..."
              className="form-textarea"
              rows={4}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button onClick={onClose} className="cancel-btn">
            Cancel
          </button>
          <button onClick={onUpdate} disabled={isUpdating} className="update-btn">
            {isUpdating ? 'Updating...' : 'Update Case'}
          </button>
        </div>
      </div>
    </>
  );
};

export default EditCaseModal;

